import { render } from "./GroupFormEL.vue?vue&type=template&id=5b87fbba"
import script from "./GroupFormEL.vue?vue&type=script&lang=js"
export * from "./GroupFormEL.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__